import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import FooterOne from "../components/FooterOne";
import StoragePage from "../components/StoragePage";

const ProfilePage = () => {
  return (
    <>
      <Preloader />

      <HeaderOne />

      <StoragePage />

      <FooterOne />
    </>
  );
};

export default ProfilePage;
